import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const SeparatorHorizontal = styled.div`
  height: 1px;
  background-color: ${ct({ Light: Colors.Dark, Dark: Colors.Dark })};
`;

export const SeparatorVertical = styled.div`
  width: 1px;
  background-color: ${ct({ Light: Colors.Dark, Dark: Colors.Dark })};
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const WrapperForVertical = styled(Wrapper)`
  display: inline-block;
`;

export const LabelWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const LabelWrapperForVertical = styled(LabelWrapper)`
  padding: 8px 0;
`;

export const LabelWrapperForHorizontal = styled(LabelWrapper)`
  padding: 0 8px;
`;
